/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const CardsWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${theme.spacing.spacing04};

  @media (min-width: ${theme.breakpoints.sm}px) {
    grid-template-columns: repeat(2, minmax(160px, 1fr));
  }

  @media (min-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: repeat(3, minmax(180px, 1fr));
  }

  @media (min-width: ${theme.breakpoints.xl}px) {
    grid-template-columns: repeat(4, minmax(180px, 1fr));
  }

  @media (min-width: ${theme.breakpoints.xxl}px) {
    grid-template-columns: repeat(6, minmax(180px, 1fr));
  }
`;
